<template>
  <section class="home">
    <div class="bgTop">
      
      <div class="top_title" @click="$router.push({name:'about'})">打理你的心爱之物</div>
      <div class="recive_tip" @click="topost()">
        {{$store.state.takeSendNum}}
        <img src="/images/home/car.png" />
      </div>
      <div class="top_price">
        <div @click="topost()">
          {{$store.state.takeSendNum}}城顺丰包邮
          <img src="/images/home/home_row.png" />
        </div>
        <div @click="toprice()">
          <img src="/images/home/money.png" class="money" />价格透明
          <img src="/images/home/home_row.png" />
        </div>
      </div>
      <div class="enter">
        <div @click="toquick()" class="enter_1">
          <img src="/images/home/enter_left.png" />
          <div>
            <p class="dero_title">直接寄包</p>
            <p class="dero">专业顾问全方位诊断</p>
          </div>
        </div>
        <div class="tr enter_2" @click="tohomeListNew()">
          <div>
            <p class="dero_title">自选下单</p>
            <p class="dero">我要自主选择修复项目</p>
          </div>
          <img src="/images/home/enter_right.png" />
        </div>
      </div>
    </div>

    <!-- <div class="list_title">创意改样
      <span>Creative change</span>
    </div>

    <div class="enter_content">
      <img
        :src="homeActive_banner | formatImgUrl(1430,709,true)"
        @click="toActive"
        class="baoqingtian"
      />
    </div> -->
    <div class="list_title">
      新人专区
    </div>
    <div class="couponBanner" @click="$router.push({name:'couponPageIndex',query:{id:1}})"></div>

    <div class="list_title" v-if="teamList.length != 0">
      活动区
      <span>Activity area</span>
    </div>

    <van-swipe
      :autoplay="3000"
      indicator-color="white"
      style="padding-bottom:5px"
      v-if="teamList.length != 0"
    >
      <van-swipe-item v-for="(item,index) in teamList" :key="index">
        <div class="active_area">
          <img
            :src='true ?"/images/home/teamTipsBg.png":"/images/home/teamTipsBg_1.png"'
            class="tipsBg"  
            v-if="item.status != 30 && item.status != 40"
          />

          <rolling
            class="rolling"
            :model="item"
            @timeEnd="timeEnd"
            :activety="true"
            v-if="item.status != 30 && item.status != 40"
          ></rolling>

          <img
            src="/images/home/new-team.png"
            @click="goPage()"
          />
          <div class="clearfix"></div>
          <div class="active_content" @click="goPage()">
            
            <div class="name_content now_sell" >
              <div style="width: 60%;float:left">
                <div class="titile-acty">{{item.groupName}}</div>
                <div class="body-acty" >
                  <div style="display: inline;" class="mku-fill">
                      <span class="num">{{item.groupMemberNum}}人团</span>
                      <span class="sell_num">已售{{item.curingServiceBo.salesNumber}}件</span>
                  </div>
                  
                  <span class="price">{{item.curingServiceBo.priceText}}</span>
                </div>
                <div style="clear:both;"></div>
              </div>
              <div  style="width: 40%;float:right">
                <button
                  v-if="status==2||status==3"
                  class="tuxedo primary"
                  @click="goPage()"
                >{{buttonText}}</button>

                <button
                  v-if="status==1||status==4"
                  class="tuxedo-disabel primary"
                  @click="goPage()"
                >{{buttonText}}</button>
              </div>
             <div style="clear:both;"></div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <div class="list_title" v-if="activityst">活动区</div>

    <div class="enter_content" v-if="activityst">
      <img
        :src="activityst.pic | formatImgUrl(1430,709,true)"
        @click="toBaoqingtian()"
        class="baoqingtian"
      />
    </div>

    <div class="list_title" ref="depth" id="depth">
      <!-- :class='{mt120:teamList.length == 0}' -->
      深度洗
      <span>Natural being</span>
    </div>

    <div class="enter_content">
      <div>
        <img src="/images/home/enter_bao.png" @click="toDetail(45)" />
      </div>
      <div>
        <img src="/images/home/enter_xie.png" @click="toDetail(46)" />
      </div>

      <div class="last_content">
        <img src="/images/home/enter_yi.png" @click="toDetail(47)" />
        <img src="/images/home/enter_pei.png" @click="toDetail(48)" />
      </div>
    </div>

    <div class="list_title">
      匠心修
      <span>Bad ≠ Bad</span>
    </div>
    <originality></originality>
    <!-- <div class='list_title'
         ref='bad'
         id='bad'>
      创意改<span>Define it</span>
    </div>-->
    <div class="creative_content">
      <!-- <div class="swiper-container">
          <div class="swiper-wrapper" ref='define' id='define'>
            <div class="swiper-slide" v-for='(item,index) in hotList' :key='index' @click='toDetail(item.id,item)'>
                <img :src='item.hotPic | formatImgUrl(323,160,true)'>
                <div class='dero'>
                    <span>{{item.name}}</span>
                    <span>¥{{item.price}}</span>
                </div>
                <div class='saleNum' >已售{{item.totalSalesNumber}}件</div>
            </div>
          </div>
    
      </div>-->
      <!-- <swiper :options="swiperOption"
              ref="mySwiper"
              class="mySwiper">
        <swiper-slide v-for="(item,index) in hotList"
                      class="swiperSlide"
                      :key="index">
          <img :src='item.hotPic | formatImgUrl(323,160,true)'
               @click='toDetail(item.id,item)'>
          <div class='dero'
               @click='toDetail(item.id,item)'>
            <span>{{item.name}}</span>
            <span>¥{{item.price}}</span>
          </div>
          <div class='saleNum'>已售{{item.totalSalesNumber}}件</div>
        </swiper-slide>
      </swiper>-->
    </div>

    <div class="shop_bag" ref="shopBag" :class="{scrolling:scroll}">
      <div class="tips_num" v-if="bagNum">{{bagNum}}</div>
      <img src="/images/public/shop_bag.png" alt @click="tobag()" />
    </div>
  </section>
</template>

<script>
import publicObj from "@/assets/js/public";
import homeApi from "@/axios/home";
import caseApi from "@/axios/case";
import { clearTimeout, setTimeout } from "timers";
import zhugeObj from "@/assets/js/track";
// import * as Swiper from 'swiper/dist/js/swiper';
import wxShare from "@/assets/js/wx.share";
import getWXConfig from "@/assets/js/wx.config";
import { swiper, swiperSlide } from "vue-awesome-swiper";
let timerout;
export default {
  name: "homeIndex",
  components: { swiper, swiperSlide },
  data() {
    return {
      homeActive_banner: 'https://baozheng-front-new.baozheng.cc/2021/05/18/25bb4d58-3902-4bf8-9c20-dd0f1bc20a4d.jpeg?x-oss-process=image/resize,m_lfit,h_{height},w_{width},color_FFFFFF,image/format,jpg',
      df: true,
      swiperOption: {
        lazy: {
          loadPrevNext: true
        },
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 15,
        preventLinksPropagation: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      },
      activety: true,
      actived: 3,
      serviceList: [],
      dataNum: {},
      activityst: null,
      bagNum: "",
      scroll: false,
      hotList: [],
      io: "",
      myTeam:null,
      status:1,//
      buttonText:'',
      teamList: []
    };
  },
  computed: {},
  created() {
    // this.getSalesNumber();
    this.getShoppingCart();
    this.getHot();
    this.getTeamList();
    this.getActivityStand();
    zhugeObj.track({
      title: "首页—曝光"
    });
  },
  mounted() {
    getWXConfig({path:'http://mi.baozheng.cc'})
    window.addEventListener("scroll", this.menu);

    this.displayShow();
    setTimeout(() => {
      let shareBody = {
        link:  window.location.href  + "&utm_source=ljfx-sy"
      };
      wxShare(shareBody);
    }, 1000);
    //  var dom = document.getElementById('wxOpenInAPP') 
    // dom.innerHTML = '<wx-open-launch-weapp path="pages/index/index.html?url=1" id="launch-btn" style="width:100%; display:block;"  username="gh_f36f18f6beed"><template><style>  .wx-btn {   color: #666; width: 100%; height:100%; display: block; text-aligin:center; }</style><button class="wx-btn">我想接这单</button></template></wx-open-launch-weapp>'
    // var launchBtn = document.getElementById('launch-btn')
    // if (!launchBtn) {
    //   return
    // }
    // launchBtn.addEventListener('launch', function (e) {
    //   console.log('success')
    // })
    // launchBtn.addEventListener('error', function (e) {
    //   console.log('fail', e.detail)
    // })
  },
  methods: {
    toActive() {
      this.$router.push({name:'homeActiveIndex'})
    },
    toBaoqingtian() {
      // window.location.href = 'https://sourl.cn/PZBirY'
      zhugeObj.track({
        title: "首页--点击贴底一口价"
      });
      let id = this.activityst.id;
      this.$router.push({ name: "serviceDetail", query: { serviceId: id } });
    },
    changeText(state) {
      if (state == 10) {
        return "即将开始";
      } else if (state > 20) {
        return "已结束";
      } 
    },
    goPage(){
      let res = this.myTeam
      let index = this.teamList[0].curingServiceBo.curingServiceGoodsBo.id
        if (!this.myTeam) {
          this.$router.push({
            name: "serviceDetail",
            query: { serviceId: index }
          });
        } else {
          this.$router.push({
            name: "teamDetail",
            query: {
              groupRecordId: res.groupActivityRecordId,
              orderCode: res.orderCode
            }
          });
        }
    },
    toDetailTeam(paems) {
      homeApi.groupHisActivity({ groupActivityId: paems.id }).then(res => {
        this.myTeam = res
        console.log(788578)
        if (paems.status == 10) {
          this.status=1
          this.buttonText = "即将开始";
        } else if(paems.status == 20){
          if (!res) {
            this.status=2
            this.buttonText = '查看详情'
          } else {
            this.status=3
            this.buttonText = '我的拼团'
          }
        } else if (paems.status > 20) {
          if (!res) {
            this.status=4
            this.buttonText =  "已结束";
          } else {
            this.status=3
            this.buttonText = '我的拼团'
          }
          
        } 
       
      });
      // homeApi.groupHisActivity({ groupActivityId: tag }).then(res => {
      //   if (!res) {
      //     this.$router.push({
      //       name: "serviceDetail",
      //       query: { serviceId: index }
      //     });
      //   } else {
      //     this.$router.push({
      //       name: "teamDetail",
      //       query: {
      //         groupRecordId: res.groupActivityRecordId,
      //         orderCode: res.orderCode
      //       }
      //     });
      //   }
      // });
    },
    timeEnd() {
      console.log(33);
      this.getTeamList();
    },
    getTeamList() {
      let token = localStorage.getItem('token');
      homeApi.groupActivity().then(res => {
        if (!res) {
          return;
        }
        this.teamList = res;
        if(!token){
          if (res[0].status == 10) {
            this.status=1
            this.buttonText = "即将开始";
          } else if(res[0].status == 20){
              this.status=2
              this.buttonText = '查看详情'
          } else if (res[0].status > 20) {
            this.status=4
            this.buttonText =  "已结束";
          } 
        }else{
          this.toDetailTeam(res[0])
        }
        // this.toDetailTeam(res[0].curingServiceBo.curingServiceGoodsBo.id,res[0].id)
      });
    },
    displayShow() {
      this.io = new IntersectionObserver(entrys => {
        entrys.forEach(element => {
          // console.log(element)
          if (element.isIntersecting) {
            this.io.unobserve(element.target);
            //执行诸葛
            this.zhugeView(element.target.id);
          }
          // this.io.unobserve(element.target);
        });
      });

      setTimeout(() => {
        this.io.observe(this.$refs.depth);
        this.io.observe(this.$refs.bad);
        this.io.observe(this.$refs.define);
      }, 1000);
      // console.log(this.$refs.define)
    },
    zhugeView(id) {
      if (id == "depth") {
        zhugeObj.track({
          title: "首页—深度洗曝光",
          content: {
            深度洗: "曝光"
          }
        });
      } else if (id == "bad") {
        zhugeObj.track({
          title: "首页—匠心修曝光",
          content: {
            匠心修: "曝光"
          }
        });
      } else if (id == "define") {
        zhugeObj.track({
          title: "首页—创意改曝光",
          content: {
            创意改: "曝光"
          }
        });
      }
    },
    tohomeListNew() {
      zhugeObj.track({
        title: "首页-进入自选下单"
      });
      this.$router.push({ name: "homeListNew" });
    },

    toquick() {
      zhugeObj.track({
        title: "首页-进入直接寄包"
      });
      this.$router.push({ name: "quick" });
    },
    tobag() {
      zhugeObj.track({
        title: "点击-首页侧边方案袋"
      });
      this.$router.push({ name: "homeBag" });
    },
    toprice() {
      zhugeObj.track({
        title: "首页-点击价格透明"
      });
      this.$router.push({ name: "feeScale" });
    },
    topost() {
      zhugeObj.track({
        title: "首页-点击顺丰包邮"
      });
      this.$router.push({ name: "scope" });
    },
    getHot() {
      homeApi.getHot().then(res => {
        this.hotList = res.records.slice(0, 3);
        this.setSwiper();
      });
    },
    getActivityStand() {
      caseApi.getActivityStand().then(res => {
        this.activityst = res;
      });
    },
    getShoppingCart() {
      homeApi.shoppingCartcount().then(res => {
        this.bagNum = res.buyQuantity;
      });
    },

    menu() {
      let _this = this;
      this.scroll = true;
      if (timerout) {
        window.clearTimeout(timerout);
      }

      timerout = setTimeout(() => {
        _this.scroll = false;
      }, 500);
    },
    setSwiper() {
      // setTimeout(()=>{
      //   new Swiper('.swiper-container', {
      //     slidesPerView: 'auto',
      //     centeredSlides: true,
      //     spaceBetween: 15,
      //   });
      // },1000)
    },
    tab(index) {
      this.actived = index;
      this.pageCont.current = 1;
      this.getHomeList();
      this.serviceList = [];
      this.finished = false;
    },
    toDetail(index, item) {
      console.log(1);
      if (index == 45) {
        zhugeObj.track({
          title: "首页—养护服务",
          content: {
            深度洗: "包包养护"
          }
        });
      } else if (index == 46) {
        zhugeObj.track({
          title: "首页—养护服务",
          content: {
            深度洗: "鞋靴养护"
          }
        });
      } else if (index == 47) {
        zhugeObj.track({
          title: "首页—养护服务",
          content: {
            深度洗: "衣库养护"
          }
        });
      } else if (index == 48) {
        zhugeObj.track({
          title: "首页—养护服务",
          content: {
            深度洗: "配饰养护"
          }
        });
      } else {
        console.log(item);

        zhugeObj.track({
          title: "首页—养护服务",
          content: {
            创意改: item.name
          }
        });
      }
      this.$router.push({ name: "serviceDetail", query: { serviceId: index } });
    }
  }
};
</script>

<style scoped lang="scss">
.couponBanner{
  width: 9.15rem;
  height: 4.53rem;
    background: url('/images/home/home_index_couponBanner.jpg') no-repeat;
    background-size: contain;
    margin: 0.53rem auto 0;
}
.baoqingtian {
  width: 100% !important;
  border-radius: 4px;
  height: 343px !important;
}
.tuxedo[disabled] {
  background: #000 !important;
  color: #fff !important;
}
.enter_1 {
  padding-left: 20px;
}
.enter_2 {
  padding-right: 20px;
}
.tipsBg {
  position: absolute;
  top: 0px;
  left: -16px;
  width: 296px !important;
  height: 64px !important;
}
.rolling {
  position: absolute;
  top: 0px;
  left: 0;
  width: 300px;
  height: 56px;
}
.tuxedo {
  // background-color: #fff !important;
  height: 84px !important;
  line-height: 84px !important;
  width: 220px !important;
  // position: absolute;
  // top: -50px;
  left: 50%;
  font-size: 28px !important;
  // margin-left: -140px;
  font-weight: 600;
  float: right;
  // color: #6aa0a4 !important;
  box-shadow: 0px 1px 6px 0px rgba(46, 79, 82, 0.1);
}
.tuxedo-disabel {
  background-color: #d2d2d2 !important;
  height: 84px !important;
  line-height: 84px !important;
  width: 220px !important;
  // position: absolute;
  // top: -50px;
  left: 50%;
  font-size: 28px !important;
  // margin-left: -140px;
  font-weight: 600;
  float: right;
  // color: #6aa0a4 !important;
  box-shadow: 0px 1px 6px 0px rgba(46, 79, 82, 0.1);
}
.num {
  padding:1px 6px;
  background-color: rgba(104, 160, 165, 1);
  color: #fff;
  line-height: 30px;
  padding-top: 3px;
  display: inline;
}
.sell_num {
  padding: 1px 30px;
  color: #68a0a5;
  line-height: 30px;
  padding-top: 3px;
  display: inline;
}
.mku-fill{
  // border: 2px solid rgba(104, 160, 165, 1);
  border-radius: 4px;
  font-size: 18px;
  // display: flex;
  box-sizing: border-box;
  height: 20px;
  line-height: 50px;
}
.titile-acty{
  width:100%;
  float:left;
  overflow: hidden;/*超出部分隐藏*/
  white-space: nowrap;/*不换行*/
  text-overflow:ellipsis;/*超出部分文字以...显示*/
}
.body-acty{
  width:100%;
  float:left;
  margin-top:10px;
}
.active_area {
  margin-top: 40px;
  margin-left: 32px;
  margin-right: 32px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  position: relative;
  img {
    width: 100%;
    height: 340px;
    float: left;
  }

  .active_content {
    position: relative;
    background: #fff;
    padding: 32px 24px;
    // padding-top:48px;
    .now_sell {
      // display: flex;
      // justify-content: flex-start;
      // margin-top: 16px;
      & > div {
        // border: 2px solid rgba(104, 160, 165, 1);
        // border-radius: 4px;
        // font-size: 18px;
        // // display: flex;
        // box-sizing: border-box;
        div {
          // padding-left: 12px;
          // padding-right: 12px;
          // line-height: 37px;
        }
        .num {
          background-color: rgba(104, 160, 165, 1);
          color: #fff;
          border: 0.02667rem solid #68a0a5;
        }
        .sell_num {
          // padding: 1px 30px;
          color: #68a0a5;
          border: 0.02667rem solid #68a0a5;
        }
      }
    }
    .name_content {
      // display: flex;
      // justify-content: space-between;
      font-size: 28px;
      line-height: 33px;
      font-weight: 400;
      .name {
        color: #333;
      }
      .price {
        color: #f96161;
        font-weight: 500;
        font-size: 32px;
        float: right;
      }
    }
  }
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  font-size: 18px;
  background: #fff;

  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;

  width: 90%;
}
.scrolling {
  right: -135px !important;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.shop_bag {
  position: fixed;
  z-index: 100;
  width: 134px;
  bottom: 200px;
  right: 0;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  .tips_num {
    position: absolute;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    top: 20px;
    left: 20px;
    background: #f24949;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
  }
  img {
    width: 100%;
  }
}

.creative_content {
  margin-top: 40px;
  .dero {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    color: #4a4a4a;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .saleNum {
    color: #9b9b9b;
    font-size: 16px;
  }
  img {
    width: 100%;
    border-radius: 5px;
  }
}
.mt120 {
  margin-top: 180px !important;
}
.enter_content {
  display: flex;
  justify-content: space-between;
  margin-left: 16px;
  margin-right: 16px;
  padding: 0 16px;
  margin-top: 40px;
  .last_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 222px;
    img {
      width: 222px !important;
      height: 138px !important;
    }
  }
  div {
    width: 216px;
  }
  img {
    width: 216px;
  }
}
.dero {
  margin-top: 10px;
  font-size: 18px;
}

.dero_title {
  font-size: 32px;
  font-weight: 500;
}
.tr {
  text-align: right;
  justify-content: flex-end;
  border-left: 1px solid #d2d2d2;
}
.list_title {
  font-size: 40px;
  color: #000;
  font-weight: 600;
  margin-top: 96px;
  margin-left: 16px;
  margin-right: 16px;
  padding: 0 16px;
  span {
    font-size: 30px;
    font-weight: normal;
    margin-left: 30px;
  }
}
.home {
  // background: #F2F2F2;
  padding-bottom: 150px;
}
.enter {
  background: #fff;
  margin-top: 48px;
  height: 160px;
  border-radius: 12px;
  left: 15px;
  bottom: -80px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.11);

  & > div {
    display: flex;

    width: 50%;
    // padding: 48px 0px;
    margin-top: 50px;
    margin-bottom: 45px;
    img {
      width: 52px;
      height: 60px;
      margin-left: 16px;
      margin-right: 16px;
    }
  }
}
.bgTop {
  height: 280px;
  margin-bottom: 140px;
  background: url("/images/home/topbg.png");
  background-size: 100%;
  padding: 46px 16px;
  position: relative;
  .top_title {
    font-size: 48px;
    color: #fff;
    font-weight: 600;
    padding: 0 16px;
  }
  .recive_tip {
    font-size: 68px;
    color: #fff;
    font-weight: 600;
    display: flex;
    margin-top: 40px;
    font-weight: 300;
    padding: 0 16px;
    img {
      width: 52px;
      height: 52px;
      margin-left: 26px;
      margin-top: 10px;
    }
  }
  .top_price {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    color: #fff;
    padding: 0 16px;
    div {
      display: flex;
      font-size: 20px;
    }
    img {
      width: 10px;
      margin-left: 14px;
      height: 18px;
    }
    .money {
      width: 20px;
      margin-right: 8px;
    }
  }
}
</style>
